var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_446_61",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_446_61",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAACQklEQVRoge2YO2gUURSG/6sRQkDxkcJCBcXEQvCBaKWIYKGFhdhZBCy01UoLQYiNtjaCjYKlBpsIYhEsBAVFtFIE3xgQTNRNFCS6+SxmB+LsubszO3t3FO4HC8vZe/7z/8PeeUmRSCQSiWQAhoBbwDeqpwaMARstr84wv0HSI0mrQh+ogkxJ2uGc+7CwuMhYeFj/nnlJGpS0O1u0AoxJehvcTnHuS7qdLTYFcM69l7RZ0qikufC+2lKTdErSPufcTKFOYAvwoMINPA6sLRUfcMAIMNVD45PAkVLGjSCrgeuBjdeBK8CyMkbPAueAAc/vB4DXAcw/A3a2OHjXgMt5AtQbgm+Ag541A8AFYK4Lxn8Ap4E+Y44DjgNf0sV5AmTxbiRgGJgoYf4eMOzRHrK0OwkAyS3FSWCx5yiNAJ8LGJ8GTnjmLwHOAD+txk4DpDzB/z9dSbIB51v0z5OcCAY9GnuA560MlA0A8Au4BCz19O8FXhh9r4D9np7lDc260df1ACnvgEMejX7gPPC18RkF+j1rjwKf8g7tZoCUcWBdW+HmOeuBO0WHhQgA8J1k4zVtckO/j+SEMNvJoFABUp4Cu1pobwcelxkQOgAYtwMkF76LwO+y4lm/1hNZ+5T5mJR0tfH9mKQ13RB1zv3lOWSAIGQDWE9k/xUxQNXEAFUTA1SNFWC25y7yU8sWrAATPTDSKXezBetKvEnSQ0kreuGoANOStjnnPi4sWq8WX0raKummpGKv8sIwI+mGDPORSCQSifwB9h5WCGStMSQAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.c3faec32470cb46cd17cab03e3aabecc.svg";
export { ForwardRef as ReactComponent };